export default "__VITE_ASSET__9d1c1e68__"